import { render, staticRenderFns } from "./ProductosCrud.vue?vue&type=template&id=33320729"
import script from "./ProductosCrud.vue?vue&type=script&lang=js"
export * from "./ProductosCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports